import { render, staticRenderFns } from "./formInvoiceBankAccount.vue?vue&type=template&id=6b6b84a2&scoped=true"
import script from "./formInvoiceBankAccount.vue?vue&type=script&lang=js"
export * from "./formInvoiceBankAccount.vue?vue&type=script&lang=js"
import style0 from "./formInvoiceBankAccount.vue?vue&type=style&index=0&id=6b6b84a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6b84a2",
  null
  
)

export default component.exports